import React, { useEffect, useState, Component, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import "./scss/style.scss";

import RouterComponent from "./routes";
import RootDialog from "src/components/Shared/RootDialog/RootDialog";
import Loader from "src/components/Shared/Loader/Loader";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useTranslation } from "react-i18next";
import GlobalPDFPreviewModal from "./PDFPreview/GlobalPDFPreviewModal";

// const loading = (
//   <div className="pt-3 text-center">
//     <div className="sk-spinner sk-spinner-pulse"></div>
//   </div>
// );

// Containers
// const DefaultLayout = React.lazy(() => import("./containers/DefaultLayout"));

// Pages
// const Login = React.lazy(() => import("./views/pages/login/Login"));
// const Register = React.lazy(() => import("./views/pages/register/Register"));
// const Page404 = React.lazy(() => import("./views/pages/page404/Page404"));
// const Page500 = React.lazy(() => import("./views/pages/page500/Page500"));

const index = () => {
  const { i18n, t } = useTranslation();
  const rootDetail = useSelector(({ root }) => root);
  const rootDialogDTO = rootDetail.rootDialogDTO || {};

  useEffect(() => {
    // Anything in here is fired on component mount.
    return () => {
      // Anything in here is fired on component unmount.
    };
  }, []);

  useEffect(() => {
    document.title = t("alMarwaAdmin", "Al-Marwa Admin");
    document.documentElement.dir = i18n.language === "ar" ? "rtl" : "ltr";
  }, [i18n.language, t]);

  return (
    <Router>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path="*" element={<RouterComponent />} />
        </Routes>
        <GlobalPDFPreviewModal />
      </Suspense>

      {rootDialogDTO.show == true ? <RootDialog /> : null}
      {rootDetail.loading == true ? <Loader /> : null}
      <ToastContainer position="top-center" />
    </Router>

    // <HashRouter>
    //   <Suspense fallback={loading}>
    //     <Routes>
    //       <Route exact path="/login" name="Login Page" element={<Login />} />
    //       <Route exact path="/register" name="Register Page" element={<Register />} />
    //       <Route exact path="/404" name="Page 404" element={<Page404 />} />
    //       <Route exact path="/500" name="Page 500" element={<Page500 />} />
    //       <Route path="*" name="Home" element={<DefaultLayout />} />
    //     </Routes>
    //   </Suspense>
    // </HashRouter>
  );
};

export default index;
